module.exports = __webpack_public_path__ + "img/Weapon_123.57565a25.png";